import { ActionWithErrorBadge } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';

import { usePayoffField } from '../../../../baseDealActivity/baseDealContainer/TradeInFields/usePayoffField';
import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { RowLabelAction } from '../../RowLabelAction';
import { ScenarioRow } from '../../ScenarioRow';

export const TradePayoffRow = () => {
    const { label, errorBadgeEntity, onLabelActivate, inputProps } = usePayoffField();
    const inputId = useScenarioCellId('tradePayoff');

    return (
        <ScenarioRow
            rowKey="tradePayoff"
            label={
                <RowLabelAction onActivate={onLabelActivate} testId="payoff-input-label">
                    <ActionWithErrorBadge entityName={errorBadgeEntity}>{label}</ActionWithErrorBadge>
                </RowLabelAction>
            }
        >
            <NumericInput {...inputProps} id={inputId} label={label} displayLabel={false} />
        </ScenarioRow>
    );
};
